import { render, staticRenderFns } from "./DirectMessagingChatEntry.vue?vue&type=template&id=1f6e05c4"
import script from "./DirectMessagingChatEntry.vue?vue&type=script&lang=ts"
export * from "./DirectMessagingChatEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports